import React, { useEffect, useState } from "react";
import moment from "moment";
import { styled } from "styled-components";
import { getPublicUrl } from "../../../../helpers/helper_functions";
import { InfoImage } from "./SharedComponents";

import "./InfoBox.css";

const AffordableFood = () => {

  return (
    <div className="info-box-wrapper right-box">
      <p className="info-text-title">It's easy, tasty, and more affordable</p>
      <div className="info-text-body" id="affordablefood">
        <p>
          {" "}
          A study by Oxford University discovered that plant-based eating is the
          most affordable diet -- they found a vegan diet reduced costs by
          nearly 1/3 for participants.{" "}
        </p>
        <p>
          Reality check, there are a lot of different ways to be vegan. With so
          many delicious dairy and meat alternatives, you can eat anything from
          warm soul food to light, clean salads -- think{" "}
          <a href="https://impossiblefoods.com/">Impossible Meat</a>{" "}
          <a href="https://www.chunkfoods.com/">Chunk Foods</a>,{" "}
          <a href="https://www.beyondmeat.com/en-US/">Beyond Meat</a>,{" "}
          <a href="https://daiyafoods.com/">Daiya Cheese</a>,{" "}
          <a href="https://www.miyokos.com/">Miyoko's Creamery</a>, , and{" "}
          <a href="https://followyourheart.com/">Follow Your Heart</a> or just
          try making something yourself!{" "}
        </p>
        <p>
          Checkout out the "Vegan Guide" for more information on vegan recipes,
          restaurants, and chefs that match your style of eating.
        </p>
      </div>
    </div>
  );
};

const AffordableFoodImage = () => {
  return (
    <InfoImage
      className="info-box-image"
      $background_image={getPublicUrl("assets/Home/veganjackfruitburgers.jpg")}
      $background_image_details={"no-repeat 50% 50%"}
    ></InfoImage>
  );
};

export default {
  info: () => <AffordableFood />,
  image: () => <AffordableFoodImage />,
};

//source: https://www.ox.ac.uk/news/2021-11-11-sustainable-eating-cheaper-and-healthier-oxford-study
